import React, { Fragment } from "react";
import useGetContract from "./core/hooks/useGetContract";
import sanitizeHtml from "sanitize-html";
import spinner from "./components/spinner";
import "./App.css";

const App = () => {
  const { loading, contractHtml } = useGetContract();

  const SanitizeHTML = ({ html }) => (
    <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />
  );

  return (
    <div className={contractHtml ? "padding" : "App"}>
      {loading
        ? spinner
        : contractHtml && (
            <Fragment>
              <SanitizeHTML html={contractHtml} />
            </Fragment>
          )}
    </div>
  );
};

export default App;
